<template>
  <div class="sale-subscription-filter">
    <snow-select
      v-model="form.finished_order"
      id="finished-select"
      label="Status da compra"
      :options="statuses"
    />

    <snow-select
      v-model="form.product_id"
      id="product-select"
      label="Produto"
      :options="productOptions"
    />

    <action-dispatcher
      v-if="form.product_id"
      :action="isSignature ? 'plan/get' : 'offer/get'"
      :parameters="{ product_id: form.product_id, limit: 1000 }"
    >
      <snow-select
        v-if="isSignature"
        id="offer-select"
        label="Plano"
        v-model="form.plan_id"
        :options="plansOptions"
        :errors="errors.plan_id"
      />
      <snow-select
        v-else
        id="offer-select"
        label="Oferta"
        v-model="form.offer_id"
        :options="offersOptions"
        :errors="errors.offer_id"
      />
    </action-dispatcher>

    <snow-input v-model="form.sck" id="sck" label="Parâmetro SCK" />

    <div class="snow-submit-buttons mt-3">
      <snow-button
        size="lg"
        text="Cancelar"
        variant="gray"
        @click="$emit('close')"
      />
      <snow-button size="lg" text="Salvar" @click="apply" />
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      statuses: [
        { id: "", name: "Todos" },
        { id: "false", name: "Realizada" },
        { id: "true", name: "Incompleta" }
      ],
      ...formFields(
        ["finished_order", "product_id", "offer_id", "plan_id", "sck"],
        { ...this.value }
      )
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("plan", ["plans"]),
    ...mapState("offer", ["offers"]),
    productOptions() {
      return [{ id: "", name: "Todos os produtos" }, ...this.products];
    },
    plansOptions() {
      return [{ id: "", name: "Todos os planos" }, ...this.plans];
    },
    offersOptions() {
      return [{ id: "", name: "Todas as ofertas" }, ...this.offers];
    },
    isSignature() {
      const slctdPrdct = this.products.find(p => p.id === this.form.product_id);
      return get(slctdPrdct, "type_product") === "signature";
    }
  },
  methods: {
    apply() {
      this.$emit("input", this.form);
      this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
.sale-subscription-filter {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
